/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unescaped-entities */
import Head from "next/head";
import Image from "next/image";
import Header from "./common/Header";
import Footer from "./common/Footer";
import styles from "../styles/Home.module.css";
import Accordion from "react-bootstrap/Accordion";
import LaptopImage from "/public/assets/images/laptop-screen.png";
import Icon1 from "/public/assets/images/h-icon-1.png";
import Icon2 from "/public/assets/images/h-icon-2.png";
import Icon3 from "/public/assets/images/h-icon-3.png";
import TabletImage from "/public/assets/images/tablet-screen.png";
import weatherLocationImage from "/public/assets/images/weather-location-tab.png";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getLandingPageData } from "../store/actions/landingPageAction";
import Link from "next/link";
import Router from "next/router";

export default function Home() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getLandingPageData());
  }, [dispatch]);
  const landingPageData = useSelector((state) => state.landingPageInfo.landingPageInfo.data);
  // console.log(Icon1, 'Props +++');

  const goToHome = (e) => {
    Router.push("/home");
    return;
  }
  return (
    <div>
      <Head>
        <title>Residen</title>
      </Head>
      <Header />
      <div className={styles.bannerWrapper}>
        <div className="container">
          <div className={styles.bannerInfo}>
            <div className="bannerCaptions">
              {/* <h3>Find your</h3>
              <h1>Next City</h1> */}

              {/* {(landingPageData && landingPageData.headerSection && landingPageData.headerSection.title) ? <>
                <span dangerouslySetInnerHTML={{ __html: landingPageData.headerSection.title }} />
              </> : null} */}
              <p>
                {(landingPageData && landingPageData.headerSection && landingPageData.headerSection.content) ? <>
                  <span dangerouslySetInnerHTML={{ __html: landingPageData.headerSection.content }} />
                </> : null}
              </p>
            </div>
            <div className="bannerImage">
              <Image src={(landingPageData && landingPageData.headerSection && landingPageData.headerSection.image) ? landingPageData.headerSection.image : LaptopImage} />
            </div>
          </div>
        </div>
      </div>
      <div className="padding-top-25 padding-bottom hwWrapper">
        <div className="container">
          <div className="cmnHeaderTitle margin-bottom-30">
            <div className="mt-3 text-center">
              {/* <Link className="btn btn-lets-start" href="/home">Research</Link> */}
              {/* <div className="mt-3 text-center" onClick={(e) => goToHome(e)}>
              <a className="btn btn-lets-start" >Let's start</a>
            </div> */}
              {/* </div> */}
              {/* <div className="mt-3 text-center" onClick={(e) => goToHome(e)}> </div> */}
              <span className="btn btn-research btn-warning">
                <Link className="btn btn-warning" href="/home"><span className="btn-inner-w"><span className="seaarch-icon"> <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill="#fff"
                    fillRule="evenodd"
                    d="M9 2a7 7 0 104.856 12.041.998.998 0 01.185-.185A7 7 0 009 2zm7.032 12.618a9 9 0 10-1.414 1.414l3.675 3.675a1 1 0 001.414-1.414l-3.675-3.675z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                </span>Démarre ta recherche ici</span></Link>
              </span>
            </div>
            {/* <h2>{(landingPageData && landingPageData.howItWorks && landingPageData.howItWorks.title) ? landingPageData.howItWorks.title : null}</h2> */}
            <h2>Comment ça marche</h2>
            <p>
              {(landingPageData && landingPageData.howItWorks && landingPageData.howItWorks.content) ? <>
                <span className="container cmn-info-style" dangerouslySetInnerHTML={{ __html: landingPageData.howItWorks.content }} />
              </> : null}
            </p>
          </div>
          <div className="row">
            {(landingPageData && landingPageData.serviceList && landingPageData.serviceList.length > 0) ? landingPageData.serviceList.map((item, index) => (
              <div className="col-md-4" key={index}>
                <div className="hk-item" >
                  <Image src={Icon1} alt='#' />
                  <h3>{item.service_name ? item.service_name : null}</h3>
                  <p>
                    {item.description ? item.description : null}
                  </p>
                </div>
              </div>
            )) : null}
          </div>
        </div>
      </div>

      <div className="padding-top padding-bottom lwWrapper">
        <div className="container">
          <div className="row lw-item-align">
            {(landingPageData && landingPageData.firstSection && landingPageData.firstSection.content) ? <>
              <span className="container cmn-info-style" dangerouslySetInnerHTML={{ __html: landingPageData.firstSection.content }} />
            </> : null}
          </div>
        </div>
      </div>

      {/* <div className="padding-top padding-bottom lwWrapper">
        <div className="container">
          <div className="row lw-item-align">
            <div className="col-md-6">
              <Image src={TabletImage} />
            </div>
            <div className="col-md-6">
              <div className="lw-item-info">
                <h3>From a specific location And/or based on weather</h3>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore mel ei harum
                  appellantur disputationi
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="padding-top padding-bottom vwWrapper">
        <div className="container">
          <div className="cmnHeaderTitle margin-bottom-50">
            <h2>Frequently Asked Questions</h2>
          </div>
          <Accordion className="faqAccordion" flush>
            {(landingPageData && landingPageData.faqs) ? landingPageData.faqs.map((item, index) => (
              <Accordion.Item eventKey={index} key={index}>
                <Accordion.Header>
                  {item.question}
                </Accordion.Header>
                <Accordion.Body>
                  {item.answer}
                </Accordion.Body>
              </Accordion.Item>
            )) : null}

          </Accordion>
        </div>
      </div>
      <div className={styles.vhWrapper}>
        <div className="container padding-top padding-bottom">
          {(landingPageData && landingPageData.secondSection && landingPageData.secondSection.content) ? <>
            <span className="container cmn-info-style" dangerouslySetInnerHTML={{ __html: landingPageData.secondSection.content }} />
          </> : null}
          {/* <div className="cmnHeaderTitle margin-bottom-50">
            <h2>Heat visibility according to weather</h2>
          </div>
          <div className="text-center">
            <Image src={weatherLocationImage} />
          </div> */}
        </div>
      </div>
      <Footer />
    </div>
  );
}
